module.exports = __webpack_public_path__ + "img/5.84b62ec2.svg";